// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Cwga","field":"styles_field__2zOFi","fieldCol":"styles_fieldCol__2l0KF","diffCol":"styles_diffCol__rkLLc","diff":"styles_diff__3TmiA"};